import styled from 'styled-components'

import { E_Colors } from '@/helpers/colors'
import { hexToRgba } from '@/helpers'


export const SC_Title = styled.h5`
  font-weight: 400;
`

export const SC_Value = styled.h3<{ $isIncome: boolean }>`
  font-weight: 600;
  color: ${(p) => (p.$isIncome ? E_Colors.Green : E_Colors.TextPrimary) as string};
  white-space: pre;
  margin-top: 4px;
`

export const SC_TransactionsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  p {
    font-size: 11px;
    color: ${hexToRgba(E_Colors.TextPrimary, 0.44)};
  }

  span {
    font-size: 11px;
  }
`
